import { authRequest } from './index.js'

export async function update_report_stats(report_id, report_meta_attributes){
  let data
  // console.log("🚀 ~ file: intervention.js:4 ~ update_report_stats ~ report_meta_attributes:", report_meta_attributes)
  // report_meta_attributes
  await authRequest.patch(
    '/report/intervention/' + report_id, 
    {report:{
      report_meta_attributes
    }}, 
    { headers: {
        'Content-Type': 'application/json'
      }
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function get_assessment(assessment_id){
  let data
  await authRequest.get(
    'assessments/' + assessment_id,
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function get_trait_intervention(id){
  let data
  await authRequest.get(
    'traits/' + id.trait +
    '/childrens/' + id.child +
    '/interventions',
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function create_intervention_progress(payload, config = {}){
  let data
  await authRequest.post(
    '/intervention_progresses',
    payload,
    config
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function get_intervention_progress(activity_id, child_id){
  let data
  await authRequest.get(
    'childrens/' + child_id +
    '/interventions/' + activity_id +
    '/activities',
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function get_image(activity_id, child_id){
  let data
  await authRequest.get(
    'intervention_progresses/' + activity_id +
    '/download_image',
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function get_media_url(progress_id){
  let data
  await authRequest.get(
    `intervention_progresses/${progress_id}/media_url`
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}


export async function getPresignedUrl(filename, contentType){
  let data
  await authRequest.post(
    '/intervention_progresses/presigned_url',
    { filename, content_type: contentType }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response?.data}
  })
  return data
}

export async function performS3Upload(file, onUploadProgressCallback) {
  const axios = (await import('axios')).default;
  const { swalError } = await import('@/helper');
  
  try {
    const presignedUrlResponse = await getPresignedUrl(file.name, file.type);
    if (presignedUrlResponse.error) {
      throw new Error(presignedUrlResponse.result.error);
    }

    const { presigned_url, public_url, object_key } = presignedUrlResponse.result.data;

    const uploadResponse = await axios.put(presigned_url, file, {
      headers: {
        'Content-Type': file.type,
      },
      onUploadProgress: (progressEvent) => {
        if (onUploadProgressCallback) {
          onUploadProgressCallback(progressEvent);
        }
      },
    });

    const checksum = uploadResponse.headers.etag ? uploadResponse.headers.etag.replace(/"/g, '') : null;

    return {
      publicUrl: public_url,
      key: object_key,
      byteSize: file.size,
      checksum: checksum,
      filename: file.name,
      contentType: file.type
    };
  } catch (error) {
    console.error("S3 upload error:", error);
    swalError(`Failed to upload ${file.name}: ${error.message || error}`);
    throw error;
  }
}